// Dados da sessão de debug guardados no navegador. Cada navegador tem seu
// próprio user_id, para duas pessoas depurando ao mesmo tempo não dividirem a
// mesma conversa no csml-server.

import { v4 as uuidv4 } from 'uuid';

const USER_KEY = 'csml-editor-user';
const METADATA_KEY = 'csml-editor-metadata';
const CODE_KEY = 'csml-editor-code';

// Mesmo formato do metadata_params do MA (conversation, contact, config)
export const DEFAULT_METADATA = {
  conversation: { id: 1, inbox_id: 1, status: 'pending' },
  contact: { id: 1, name: 'Contato Teste', phone_number: '+5524999999999', email: 'contato@teste.com' },
  config: { N8N_ADDRESS: '' }
};

function read(key) {
  try { return localStorage.getItem(key); } catch (e) { return null; }
}

function write(key, value) {
  try { localStorage.setItem(key, value); } catch (e) { /* sem storage */ }
}

export function loadSessionData() {
  let userID = read(USER_KEY);
  if (!userID) {
    userID = `editor-${uuidv4().slice(0, 8)}`;
    write(USER_KEY, userID);
  }
  return {
    botID: 'BotDevTeste',
    userID,
    channelID: 'Studio'
  };
}

export function loadMetadata() {
  try {
    return JSON.parse(read(METADATA_KEY)) || DEFAULT_METADATA;
  } catch (e) {
    return DEFAULT_METADATA;
  }
}

export function saveMetadata(metadata) {
  write(METADATA_KEY, JSON.stringify(metadata));
}

export function loadCode() {
  return read(CODE_KEY) || '';
}

export function saveCode(code) {
  write(CODE_KEY, code);
}
